// CJS `exports.default = class` double-wraps under Vite ESM interop
import SnackbarModule from "awesome-snackbar";

const Snackbar = (SnackbarModule as any).default ?? SnackbarModule;

import { Translations, i18n } from "@i18n";
import { useTheme } from "./useTheme";

export const useErrorBanner = () => {
  const { theme } = useTheme();

  const showErrorBanner = (messageProp?: string) => {
    const message = messageProp ?? i18n.t(Translations.ErrorBannerDefaultMessage);

    new Snackbar(`<p class="errorBanner">${message}</p>`, {
      position: "bottom-center",
      style: {
        container: [["background-color", theme.error.background]],
      },
    });
  };

  return { showErrorBanner };
};
